module.exports = __webpack_public_path__ + "assets/img/4-3.d4ac40f4.png";